import type { FaireProductEntity } from "../../entity_types/product";

export const p_ttq445duu9: FaireProductEntity = {
  token: "p_ttq445duu9",
  type: "product",
  name: "Damn Girl You Look Fine As Fuck | Funny Birthday Card | 70's Vintage",
  brandName: "Sleazy Greetings",
  imageUrl:
    "https://cdn.faire.com/fastly/b4e7107d05af3b3a42c1bd7cabe94c2dadd8134d83ae0c264f399431499b15ad.png",
  priceDollars: 2.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b36629ad14fb04ad2aa74da4b599f47afc31ff7343133c7c16efbee883bbcdbe.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
